// Enable to add a dynamic Link to translation using Trans component
// https://www.createit.com/blog/i18next-react-links-inside-translations/#Trans_and_LinkText_component
export const LinkText = ({ to, title, children }: { to: string; title?: string; children?: string }): any => {
  return (
    <a href={to} target="_blank" title={title} rel="noreferrer">
      {children}
    </a>
  );
};
